// React
import { useState } from "react";

// React redux
import { useDispatch } from "react-redux";

// @mui material components
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Breadcrumbs, CircularProgress } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

// Material Dashboard 2 React example components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Service
import { remove } from "services/lesson/lessons.services";

function DeleteDialog({ lessonId, finished }) {
  const [loading, setLoading] = useState(false);
  const dispatchApi = useDispatch();

  const handleDelete = async () => {
    setLoading(true);
    await remove(lessonId).then(() => dispatchApi({ type: "DELETED_LESSON", lessonId }));
    setLoading(false);
    finished();
  };

  return (
    <Dialog open>
      <DialogTitle>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Leçons
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Suppression
          </MDTypography>
        </Breadcrumbs>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>Voulez vous vraiment supprimer cette leçon?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={finished} disabled={loading} variant="text" color="info" size="small">
          Non
        </MDButton>
        <MDButton
          onClick={handleDelete}
          disabled={loading}
          variant="text"
          color="primary"
          size="small"
        >
          Oui
          {loading && (
            <CircularProgress size="1.5em" color="info" style={{ position: "absolute" }} />
          )}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

DeleteDialog.propTypes = {
  lessonId: PropTypes.number.isRequired,
  finished: PropTypes.func.isRequired,
};

export default DeleteDialog;
